const ua = window.navigator.userAgent
const mobileAgents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']

const isWeixin = ua.match(/MicroMessenger/i) == 'MicroMessenger'
const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
const isAndroidApp = ua.indexOf('qxyAndroidApp') > -1
const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
const isiOSApp = ua.indexOf('qxyiOSApp') > -1
const isTBSX5 = ua.match(/MQQBrowser/i) == 'MQQBrowser' || ua.match(/TBS/i) == 'TBS'
const isOldVerApp = (isAndroidApp || isiOSApp) && ua.indexOf('qxyEcpt') < 0

let isMobile = false
for (let v = 0; v < mobileAgents.length; v++) {
  if (ua.indexOf(mobileAgents[v]) > 0) {
    isMobile = true
    break
  }
}

let iosInputBlur = function () { // 兼容ios输入框
  if(isiOS) { // 判断是否为IOS系统
    setTimeout(() => {
      const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
      window.scrollTo(0, Math.max(scrollHeight - 1, 0))
    }, 100)
  }
}

export default {
  isWeixin,
  isMobile,
  isiOS,
  isiOSApp,
  isAndroid,
  isAndroidApp,
  isTBSX5,
  isOldVerApp,
  iosInputBlur
}